import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api, { Customer } from '../lib/api'

export default function CustomersPage() {
  const [items, setItems] = useState<Customer[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [q, setQ] = useState('')

  const load = async (query?: string) => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.customers.list({ q: query || undefined })
      setItems(res.data)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to load customers')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Customers</h1>
        <Link to="/customers/new" className="px-3 py-2 rounded bg-blue-700 text-white text-sm">New Customer</Link>
      </div>

      <form
        className="flex gap-2"
        onSubmit={(e) => {
          e.preventDefault()
          void load(q)
        }}
      >
        <input className="border rounded px-3 py-2 text-sm w-full" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search customers..." />
        <button className="border rounded px-3 py-2 text-sm">Search</button>
      </form>

      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      {loading ? <div className="text-sm text-gray-500">Loading customers...</div> : null}

      {!loading && !items.length ? <div className="text-sm text-gray-500">No customers found.</div> : null}

      <div className="bg-white border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-3 py-2">Account</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Type</th>
              <th className="px-3 py-2">Phone</th>
              <th className="px-3 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t">
                <td className="px-3 py-2"><Link className="text-blue-700" to={`/customers/${c.id}`}>{c.accountNumber}</Link></td>
                <td className="px-3 py-2">{c.name}</td>
                <td className="px-3 py-2">{c.customerType ?? 'OTHER'}</td>
                <td className="px-3 py-2">{c.phone ?? '-'}</td>
                <td className="px-3 py-2">{c.status ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
